import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ChannelApiService, IChannel, SnackBarConfig } from '../../../shared';
import { trackById } from '../../../shared/util/track-by.util';

@Component({
  selector: 'lum-channel-product-sync-product-form',
  templateUrl: './channel-product-sync-products-form.component.html',
  styleUrls: ['./channel-product-sync-products-form.component.scss'],
})
export class ChannelProductSyncProductsFormComponent implements OnInit {
  form :UntypedFormGroup;
  private onDestroy$ = new Subject();
  channels :IChannel[] = [];
  trackById = trackById;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data :any,
    private dialogRef :MatDialogRef<ChannelProductSyncProductsFormComponent>,
    private fb :UntypedFormBuilder,
    private channelApiService :ChannelApiService,
    private snackBar :MatSnackBar,
  ) {}

  ngOnInit() :void {
    if (!this.data?.channel) {
      this.getDataFromService();
    } else {
      this.channels = [this.data.channel];
    }

    this.initForm();
  }

  onSubmit() :void {
    this.dialogRef.close(this.form.value);
  }

  onClose() :void {
    this.dialogRef.close();
  }

  private getDataFromService() :void {
    const params :any = {
      columns: 'id,label,push_stocks_app_integration_account_id',
      ...this.data,
    };
    this.channelApiService
      .getAll(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (response :IChannel[]) => {
          this.channels = response;
        },
        error: (response :any) => {
          const message = response.error ?? 'Failed to sync products.';
          this.snackBar.open(message, 'Fail', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
        },
      });
  }

  private initForm() :void {
    this.form = this.fb.group({
      channelIds: [null, [Validators.required]],
      isNewProducts: [false],
    });
  }

  get hasChannelPushStockOms() :boolean {
    return this.data?.withPushStocksAppIntegrationAccount || false;
  }
}
